import { useRef } from 'react'

import { dislikeChatroomMessage, likeChatroomMessage } from '../../../../api'
import { useNotification } from '../../../../hooks'
import {
  getChatroomMessageNextLikeState,
  isChatroomMessageLiked,
} from '../ChatroomMessage.utils'

export function useChatroomMessageLike({
  message,
  outboundUuid,
  onUpdateMessage,
}) {
  const { handleAddErrorNotification } = useNotification()

  const isRequestingRef = useRef(false)

  function handleToggleLike() {
    if (!isRequestingRef.current && message?.uuid && onUpdateMessage) {
      const nextIsLiked = !isChatroomMessageLiked(message)
      const api = nextIsLiked ? likeChatroomMessage : dislikeChatroomMessage

      isRequestingRef.current = true

      api({ outboundUuid, uuid: message.uuid })
        .then(response => {
          if (response) {
            onUpdateMessage(
              message.uuid,
              getChatroomMessageNextLikeState({ isLiked: nextIsLiked, message })
            )
          }
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
        .finally(() => {
          isRequestingRef.current = false
        })
    }
  }

  return { handleToggleLike }
}
